import React, {useEffect, useState} from "react";
import {Col, Container, Modal, Row, Button} from 'react-bootstrap';
import APICom from "../../../utils/helpers/APICom";
import axios from 'axios';
import { mainstore } from "../../../store";

//const mrms_reportingapi_url  = process.env.REACT_APP_MRMS_REPORTING_API;
const TripHistoryDialog = (props) => {
    const [displayNoDataAlert, setDisplayNoDataAlert] = useState(false);
    const [noDataAlert, setNoDataAlert] = useState({alertTitle: '', alertMsg: ''});
    const [ShowMainDialogue, setShowMainDialogue] = useState(true);

    const handleCloseTripHistoryDialog = () => {
        if (props.showTripHistoryDialog) {
            props.setTripHistoryDialog(false);
        }
    }

    function callAlertNoSignature() {
        setShowMainDialogue(false);
        setNoDataAlert({
            alertTitle: 'Alert',
            alertMsg: 'Unable to open report, please try again'
        });
        setDisplayNoDataAlert(true);
    }

    const handleAlertModalClose = () => {
        setDisplayNoDataAlert(false);
        if(ShowMainDialogue == false){
            handleCloseTripHistoryDialog();
        }
    }

    const handleTripHistoryReport = async () => {
        let lastIndex = props.GridRowData.length - 1;
        let rptType = props.GridRowData[lastIndex].bIsSchedule == false ? "DetailHistoryServiceReport" : "TimeCallDetailedHistoryReport";
        let service_id = props.GridRowData[lastIndex].ServiceID;
        let scheduleID = props.GridRowData[lastIndex].iScheduleID;
        try{
            if(scheduleID == null){
                scheduleID = "-1";
            }
        }
        catch(ert) { }
        try {
            const response = await APICom.fetchData("AspDotNetCoreURL", `TripHistoryReports/GetTripHistoryReportData?serviceID=${service_id}&scheduleID=${scheduleID}&rptType=${rptType}`, "get", {}, {});
            let json_data = response.data;
            if (json_data.Message == "Error!") {
                callAlertNoSignature();
                // handleCloseTripHistoryDialog();
                return;
            }
            let mrms_reportingapi_url = mainstore.getState().configuration.REACT_APP_MRMS_REPORTING_API;
            let url = mrms_reportingapi_url +'TripReport';
            if (rptType === "TimeCallDetailedHistoryReport") {
                url = mrms_reportingapi_url+ 'TimeCallDetailedHistoryReport';
            }
            const pdfResponse = await axios.post(url, json_data, {
                responseType: 'arraybuffer',
            });

            if (pdfResponse.status === 200) {
                const blob = new Blob([pdfResponse.data], {type: "application/pdf"});
                const pdfUrl = URL.createObjectURL(blob);

                window.open(pdfUrl, '_blank');
                URL.revokeObjectURL(pdfUrl);
            } 
            else {
                callAlertNoSignature();
                console.error('Failed to fetch the report.');
            }
        } 
        catch (error) {
            console.error(error);
            callAlertNoSignature();
        }
    }

    const handleBidHistroyReport = async () => {
        let lastIndex = props.GridRowData.length - 1;
        let service_id = props.GridRowData[lastIndex].ServiceID;

        try {
            const response = await APICom.fetchData("AspDotNetCoreURL", `BidHistoryReports/GetBidHistoryReportData?serviceID=${service_id}`, "get", {}, {});
            let json_data = response.data;
            if (json_data.Message == "Error!") {
                callAlertNoSignature();
                // handleCloseTripHistoryDialog();
                return;
            }
            let mrms_reportingapi_url = mainstore.getState().configuration.REACT_APP_MRMS_REPORTING_API;
            let url = mrms_reportingapi_url + 'ShowBidHistoryReport';

            const pdfResponse = await axios.post(url, json_data, {
                responseType: 'arraybuffer',
            });

            if (pdfResponse.status === 200) {
                const blob = new Blob([pdfResponse.data], {type: "application/pdf"});
                const pdfUrl = URL.createObjectURL(blob);

                window.open(pdfUrl, '_blank');
                URL.revokeObjectURL(pdfUrl);
            } else {
                callAlertNoSignature();
                console.error('Failed to fetch the report.');
            }
        } catch (error) {
            console.error(error);
            callAlertNoSignature();
        }
    }
    useEffect(() => {
        if(props.GridRowData === null || props.GridRowData.length <= 0)
        {
            //handleCloseTripHistoryDialog();
            setShowMainDialogue(false);
            setNoDataAlert({
                alertTitle: 'No Record Selected',
                alertMsg: 'Please select a record to generate report'
            });
            setDisplayNoDataAlert(true);
            console.log('displayNoDataAlert:', props.showTripHistoryDialog);
        }
    }, []);



    return (
        <>
            <Modal show={ShowMainDialogue} centered onHide={handleCloseTripHistoryDialog} backdrop="static"
                   keyboard={true} animation={true} size="md" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header className='activate_dialog_header_bgcolor' closeButton>
                    <Modal.Title className="activate_dialog_title_color user-select-none">Print Report</Modal.Title>
                </Modal.Header>
                <Modal.Body className="grid-example user-select-none">
                    <Container>
                        <Row>
                            
                            <Col>
                                <Button className="tripaction_btn_color w-100" value="Trip History"
                                        onClick={handleTripHistoryReport}>Trip History</Button>
                            </Col>
                            
                            <Col>
                                <Button className="tripaction_btn_color w-100" value="Bid History"
                                        onClick={handleBidHistroyReport}>Bid History</Button>
                            </Col>
                            
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
            {displayNoDataAlert && (
                <Modal centered show={displayNoDataAlert} onHide={handleAlertModalClose} keyboard={true} animation={true} backdrop="static">
                    <Modal.Header className='noshow_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                        <Modal.Title className='noshow_dialog_title_color user-select-none'>
                            {noDataAlert.alertTitle}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="user-select-none">
                        <b>{noDataAlert.alertMsg}</b>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleAlertModalClose}>OK</Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}

export default TripHistoryDialog;
